import React, { useContext, useEffect, useState } from "react";
import dayjs from "dayjs";

import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";

import { UserContext } from "../../../../context";
import ProjectComment from "./ProjectComment";
import ProjectCommentInput from "./ProjectCommentInput";

export default function ProjectCommentSection(props) {
    const [comments, setComments] = useState([]);
    const { currentUserData } = useContext(UserContext);

    useEffect(() => {
        // Project comments are flat, so a deleted one has no replies to hold
        // together and simply disappears.
        const visibleComments = (props.component.comments || [])
            .filter((comment) => !comment.deleted)
            .filter(
                (comment) =>
                    props.canEdit || comment.user === currentUserData.key,
            )
            .sort((a, b) => dayjs(b.date).diff(dayjs(a.date)));

        setComments(visibleComments);
    }, [props, currentUserData]);

    return (
        <Box sx={{ p: { xs: 1.5, sm: 2.5 } }}>
            <Paper
                variant="outlined"
                sx={{
                    p: { xs: 1.5, sm: 2 },
                    borderRadius: 2.5,
                    borderColor: "divider",
                }}
            >
                <ProjectCommentInput
                    component={props.component}
                    projectKey={props.projectKey}
                    avatarSize="medium"
                />
            </Paper>

            <Box
                sx={{
                    mt: 2,
                    mb: 1,
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                }}
            >
                <Typography variant="subtitle1" sx={{ fontWeight: 800 }}>
                    Conversation
                </Typography>
                <Chip size="small" label={comments.length} />
            </Box>

            {comments.length === 0 ? (
                <Paper
                    variant="outlined"
                    sx={{
                        px: 2,
                        py: 4,
                        borderRadius: 2.5,
                        textAlign: "center",
                    }}
                >
                    <Typography variant="body2" color="text.secondary">
                        No comments yet. Start the conversation above.
                    </Typography>
                </Paper>
            ) : (
                <Box sx={{ display: "grid", gap: 1.5 }}>
                    {comments.map((comment) => (
                        <Paper
                            key={comment.key}
                            variant="outlined"
                            sx={{
                                p: 1.5,
                                borderRadius: 2.5,
                                overflow: "hidden",
                            }}
                        >
                            <ProjectComment
                                comment={comment}
                                component={props.component}
                                projectKey={props.projectKey}
                                avatarSize="medium"
                                isOwnComment={
                                    comment.user === currentUserData.key
                                }
                            />
                        </Paper>
                    ))}
                </Box>
            )}
        </Box>
    );
}
